(function () {
  const script = document.createElement("script");
  script.src = "https://unpkg.com/swiper/swiper-bundle.min.js";
  script.onload = function () {
    const swiper = new Swiper(".sliderComponent", {
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      on: {
        slideChangeTransitionStart: function () {
          document
            .querySelectorAll(".swiper-slide video")
            .forEach((v) => {
              v.pause();
            });
        },
        slideChangeTransitionEnd: function () {
          const activeSlide = document.querySelector(".swiper-slide-active video");
          if (activeSlide) {
            activeSlide.play().catch(() => {});
          }
        }
      }
    });
  };
  document.body.appendChild(script);

  const style = document.createElement("link");
  style.rel = "stylesheet";
  style.href = "https://unpkg.com/swiper/swiper-bundle.min.css";
  document.head.appendChild(style);
})();
